import React, { useEffect, useRef, useState } from "react";
import PDFObject from "pdfobject";
import "./PDFObjectViewer.scss";

interface PDFObjectViewerProps {
  url: string;
  width?: string | number;
  height?: string | number;
  fallbackLink?: string | null;
  pdfOpenParams?: Record<string, any> | null;
  className?: string;
}

const PDFObjectViewer: React.FC<PDFObjectViewerProps> = ({
  url,
  width = "100%",
  height = "100vh",
  fallbackLink = null,
  pdfOpenParams = null,
  className = "",
}) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && url) {
      // Embed the PDF
      let options = {
        pdfOpenParams: pdfOpenParams || null,
        fallbackLink:
          fallbackLink ||
          "<p>This browser does not support inline PDFs. Please download the PDF to view it: <a href='[url]'>Download PDF</a></p>",
      };

      PDFObject.embed(url, containerRef.current, options);
    }
  }, [url]);

  const containerStyle: React.CSSProperties = {
    width: typeof width === "number" ? `${width}px` : width,
    height: typeof height === "number" ? `${height}px` : height,
  };

  return (
    <div
      className={`pdfobject-viewer-container ${className}`}
      style={containerStyle}
    >
      <div ref={containerRef} className="pdfobject-embed-wrapper"></div>
    </div>
  );
};

export default PDFObjectViewer;
